import { Injectable } from "@angular/core";
import { LanguageHelperService } from "./language-helper.service";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class ConfirmationService {
  constructor(private langHelper: LanguageHelperService) {}

  /**
   * Show a delete confirmation dialog
   * @param callback Function to execute if confirmed
   */
  showDeleteConfirmation(callback: () => void): void {
    const texts = this.langHelper.getConfirmationTexts();

    Swal.fire({
      title: texts.title,
      text: texts.text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: texts.cancelButtonText,
      confirmButtonText: texts.confirmButtonText,
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
  }

  /**
   * Show a custom confirmation dialog
   * @param title Dialog title
   * @param text Dialog text
   * @param confirmButtonText Confirm button text
   * @param callback Function to execute if confirmed
   */
  showCustomConfirmation(
    title: string,
    text: string,
    confirmButtonText: string,
    callback: () => void
  ): void {
    const texts = this.langHelper.getConfirmationTexts();

    Swal.fire({
      title: title,
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: texts.cancelButtonText,
      confirmButtonText: confirmButtonText,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        callback();
      }
    });
  }
}
